// @flow
import React from "react";
import { useSelector } from "react-redux";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoVisualizacaoCarteira,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

export const processarPontualMensalCarteiraEmNiveis = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        visualizacaoCarteira: edicaoMedida.visualizacaoCarteira,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: 2,
        ajusteDias: edicaoMedida.ajusteDias,
        dataBase: dataBase,
        visualizacaoCarteira: edicaoMedida.visualizacaoCarteira,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PontualMensalCarteiraEmNiveis = () => {
  const modoSeries = useSelector(isModoSeries);

  return (
    <>
      <SelecaoPeriodo exibirPeriodicidade={false} />
      <div className="ConfiguracaoMedida__box">
        <SelecaoAjusteDias />
        <SelecaoVisualizacaoCarteira />
      </div>
      <div className="ConfiguracaoMedida__vertical-divider" />
      {!modoSeries && <SelecaoCasasDecimais />}
    </>
  );
};

export default PontualMensalCarteiraEmNiveis;
